import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=productBrandStrategy&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs_small',
        slogan: '',
        pageTitle: '品牌战略',
        pageTitleIcon: '',
        background_img: '',
        description: `华美专注于帮助酒店业主解决品牌定位模糊、市场竞争力不足及收益增长瓶颈等核心问题。许多酒店常陷入同质化竞争，缺乏清晰的品牌调性，或无法将品牌价值有效转化为商业回报。华美通过市场诊断与数据分析，精准识别品牌差异化机会，构建品牌框架，设计可执行的商业转化路径。`,
        icons: [
            {
                name: '品牌战略',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/17.品牌战略.pdf'),
                path: "四库赋能-酒店+/产品及品牌战略/品牌战略"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店+/品牌战略/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/品牌战略/数据赋能'),
                path: "四库赋能-酒店+/品牌战略/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/产品及品牌战略/全球案例/全球案例（产品及品牌战略）.xlsx'),
                path: "四库赋能-酒店+/产品及品牌战略/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/产品及品牌战略/预警问题/预警问题（产品及品牌战略）.xlsx'),
                path: "四库赋能-酒店+/产品及品牌战略/预警问题"
            }
        ]
    }]
}